import { render, staticRenderFns } from "./business-auth-list.vue?vue&type=template&id=668295c2&scoped=true&"
import script from "./business-auth-list.vue?vue&type=script&lang=js&"
export * from "./business-auth-list.vue?vue&type=script&lang=js&"
import style0 from "./business-auth-list.vue?vue&type=style&index=0&id=668295c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668295c2",
  null
  
)

export default component.exports